export enum ResourceAuthEnum {
    //客户账户管理 （查看）
    ACC_C_VW = "fms.ac.c.vw",
    //客户账户管理 （账户初始化）
    ACC_C_INIT = "fms.ac.c.init",

    //客户账户管理详情 （账户信息）
    ACC_C_VW_AC = "fms.ac.c.vw.ac",
    //客户账户管理详情 （账户信息-开户）
    ACC_C_VW_AC_INIT = "fms.ac.c.vw.ac.init",
    //客户账户管理详情 （账户信息-调额）
    ACC_C_VW_AC_ADJ = "fms.ac.c.vw.ac.adj",
    //客户账户管理详情 （账户信息-充值）
    ACC_C_VW_AC_CHARG = "fms.ac.c.vw.ac.charg",
    //客户账户管理详情 （账户信息-转账）
    ACC_C_VW_AC_TRANS = "fms.ac.c.vw.ac.trans",
    //客户账户管理详情 （账户信息-核销账单）
    ACC_C_VW_AC_W_OFF = "fms.ac.c.vw.ac.w-off",
    //客户账户管理详情 （账户信息-启用禁用）
    ACC_C_VW_AC_DISABLE = "fms.ac.c.vw.ac.disable",
    //客户账户管理详情 （账户信息-启用禁用）
    ACC_B_VW_AC_DISABLE = "fms.ac.b.vw.ac.disable",
    //客户账户管理详情 （调额记录）
    ACC_C_VW_ADJ = "fms.ac.c.vw.adj",
    //客户账户管理详情 （调额记录-审核）
    ACC_C_VW_ADJ_AUDIT = "fms.ac.c.vw.adj.audit",
    //客户账户管理详情 （调额记录-撤回）
    ACC_C_VW_ADJ_RETURN = "fms.ac.c.vw.adj.return",

    //客户账户管理详情 （充值记录）
    ACC_C_VW_CHARG = "fms.ac.c.vw.charg",
    //客户账户管理详情 （充值记录-审核）
    ACC_C_VW_CHARG_AUDIT = "fms.ac.c.vw.charg.audit",
    //客户账户管理详情 （充值记录-撤回）
    ACC_C_VW_CHARG_RETURN = "fms.ac.c.vw.charg.return",
    //客户账户管理详情 （转账记录）
    ACC_C_VW_TRANS = "fms.ac.c.vw.trans",

    //客户账户管理详情 （账单信息）
    ACC_C_VW_BILL = "fms.ac.c.vw.bill",
    //客户账户管理详情 （账单信息-核销）
    ACC_C_VW_BILL_W_OFF = "fms.ac.c.vw.bill.w-off",
    //客户账户管理详情 （账单信息-批量核销）
    ACC_C_VW_BILL_W_OFF_BATCH = "fms.ac.c.vw.bill.w-off-batch",

    //客户账户管理详情 （核销记录）
    ACC_C_VW_W_OFF = "fms.ac.c.vw.w-off",
    //客户账户管理详情 （操作日志）
    ACC_C_VW_LOG = "fms.ac.c.vw.log",

    //供应商账户管理 （查看）
    ACC_S_VW = "fms.ac.s.vw",
    //供应商账户管理 （账户初始化）
    ACC_S_INIT = "fms.ac.s.init",

    //供应商账户管理详情 （账户信息）
    ACC_S_VW_AC = "fms.ac.s.vw.ac",
    //供应商账户管理详情 （账户信息-开户）
    ACC_S_VW_AC_INIT = "fms.ac.s.vw.ac.init",
    //供应商账户管理详情 （账户信息-调额）
    ACC_S_VW_AC_ADJ = "fms.ac.s.vw.ac.adj",
    //供应商账户管理详情 （账户信息-充值）
    ACC_S_VW_AC_CHARG = "fms.ac.s.vw.ac.charg",
    //供应商账户管理详情 （账户信息-转账）
    ACC_S_VW_AC_TRANS = "fms.ac.s.vw.ac.trans",
    //供应商账户管理详情 （账户信息-核销账单）
    ACC_S_VW_AC_W_OFF = "fms.ac.s.vw.ac.w-off",
    //供应商账户管理详情 （账户信息-批量核销）
    ACC_S_VW_AC_W_OFF_BATCH = "fms.ac.s.vw.ac.w-off-batch",
    //供应商账户管理详情 （账户信息-启用禁用）
    ACC_S_VW_AC_DISABLE = "fms.ac.s.vw.ac.disable",
    //客户账户管理详情 （账户信息-启用禁用）
    ACC_SU_VW_AC_DISABLE = "fms.ac.su.vw.ac.disable",
    //供应商账户管理详情 （调额记录）
    ACC_S_VW_ADJ = "fms.ac.s.vw.adj",
    //供应商账户管理详情 （调额记录-审核）
    ACC_S_VW_ADJ_AUDIT = "fms.ac.s.vw.adj.audit",
    //供应商账户管理详情 （调额记录-撤回）
    ACC_S_VW_ADJ_RETURN = "fms.ac.s.vw.adj.return",

    //供应商账户管理详情 （充值记录）
    ACC_S_VW_CHARG = "fms.ac.s.vw.charg",
    //供应商账户管理详情 （充值记录-审核）
    ACC_S_VW_CHARG_AUDIT = "fms.ac.s.vw.charg.audit",
    //供应商账户管理详情 （充值记录-撤回）
    ACC_S_VW_CHARG_RETURN = "fms.ac.s.vw.charg.return",
    //供应商账户管理详情 （转账记录）
    ACC_S_VW_TRANS = "fms.ac.s.vw.trans",

    //供应商账户管理详情 （账单信息）
    ACC_S_VW_BILL = "fms.ac.s.vw.bill",
    //供应商账户管理详情 （账单信息-核销）
    ACC_S_VW_BILL_W_OFF = "fms.ac.s.vw.bill.w-off",

    //供应商账户管理详情 （核销记录）
    ACC_S_VW_W_OFF = "fms.ac.s.vw.w-off",
    //供应商账户管理详情 （操作日志）
    ACC_S_VW_LOG = "fms.ac.s.vw.log",
    //供应商账户管理详情 （账单结算）
    ACC_S_VW_SETTLE = "fms.ac.s.vw.settle",


    //现金收款 (待收)
    CASH_RECEI_WILL = "fms.cash.recei.will",
    //现金收款 (待收-收款)
    CASH_RECEI_WILL_RECEI = "fms.cash.recei.will.recei",
    //现金收款 (待收-批量收款)
    CASH_RECEI_WILL_RECEI_BATCH = "fms.cash.recei.will.recei-batch",
    //现金收款 (已收)
    CASH_RECEI_DONE = "fms.cash.recei.done",
    //现金收款 (已收-查看支付明细)
    CASH_RECEI_DONE_VW = "fms.cash.recei.done.vw",

    //现金付款 (待付)
    CASH_PAY_WILL = "fms.cash.pay.will",
    //现金付款 (待付-付款)
    CASH_PAY_WILL_PAY = "fms.cash.pay.will.pay",
    //现金付款 (待付-批量付款)
    CASH_PAY_WILL_PAY_BATCH = "fms.cash.pay.will.pay-batch",
    //现金付款 (已付)
    CASH_PAY_DONE = "fms.cash.pay.done",
    //现金付款 (已付-查看支付明细)
    CASH_PAY_DONE_VW = "fms.cash.pay.done.vw",

    //应用系统管理(查看)
    DATA_APP_VW = "fms.data.app.vw",
    //应用系统管理(同步)
    DATA_APP_SYNC = "fms.data.app.sync",

    //组织机构管理(刷新)
    DATA_ORG_REFRESH = "fms.data.org.refresh",
    //组织机构管理(同步)
    DATA_ORG_SYNC = "fms.data.org.sync",

    //经营实体管理(查看)
    DATA_ENTITY_VW = "fms.data.entity.vw",
    //经营实体管理(同步)
    DATA_ENTITY_SYNC = "fms.data.entity.sync",
    //经营实体管理(新增)
    DATA_ENTITY_ADD = "fms.data.entity.ad",
    //经营实体管理(修改)
    DATA_ENTITY_ED = "fms.data.entity.ed",
    //经营实体管理(禁用)
    DATA_ENTITY_DISABLE = "fms.data.entity.disable",

    //客户信息管理(查看)
    DATA_C_VW = "fms.data.c.vw",
    //客户信息管理(同步)
    DATA_C_SYNC = "fms.data.c.sync",

    //供应商管理(查看)
    DATA_S_VW = "fms.data.s.vw",
    //供应商管理(同步)
    DATA_S_SYNC = "fms.data.s.sync",

    //数据字典管理(增加下级)
    DATA_DICT_SUB = "fms.data.dic.sub",
    //数据字典管理(增加同级)
    DATA_DICT_BRO = "fms.data.dic.bro",
    //数据字典管理(同步)
    DATA_DICT_SYNC = "fms.data.dic.sync",

    //仓库管理(查看)
    DATA_W_VW = "fms.data.w.vw",
    //仓库管理(同步)
    DATA_W_SYNC = "fms.data.w.sync",

    //系统配置管理(新增)
    DATA_SYS_ADD = "fms.data.sys.ad",
    //系统配置管理(同步)
    DATA_SYS_SYNC = "fms.data.sys.sync",
    //系统配置管理(刷新)
    DATA_SYS_REFRESH = "fms.data.sys.refresh",

    //门店管理(查看)
    DATA_SHOP_VW = "fms.data.shop.vw",
    //门店管理(同步)
    DATA_SHOP_SYNC = "fms.data.shop.sync",

    //客户账单管理-导出
    BILL_C_EX = "fms.biil.c.ex",
    //客户账户管理-账单信息-导出
    ACC_BILL_C_EX = "fms.ac.c.vw.bill.ex",
    //供应商账单管理-导出
    BILL_S_EX = "fms.biil.s.ex",
    //供应商账户管理-账单信息-导出
    ACC_BILL_S_EX = "fms.ac.s.vw.bill.ex",

    //客户优惠单-财务审核
    ACC_C_ED_F_APPROVE = "fms.ac.c-yh.ed.f-approve",
    //客户优惠单-申请
    ACC_C_AD_APPLY = "fms.ac.c-yh.ad.apply",
    //客户优惠单-机构审核
    ACC_C_ED_D_APPROVE = "fms.ac.c-yh.ed.d-approve",
    //客户优惠单-新增
    ACC_C_YH_AD = "fms.ac.c-yh.ad",
    //客户优惠单-编辑
    ACC_C_YH_ED = "fms.ac.c-yh.ed",
    //客户优惠单-导出
    ACC_C_YH_EX = "fms.ac.c-yh.ex",

    //库存统计-导出
    ST_STOCK_EX = "fms.st.stock.ex",
    //库存统计-库存同步
    ST_STOCK_SYNC = "fms.st.stock.sync",
    //物料管理-同步
    DATA_M_SYNC = "fms.data.m.sync",

    //内部核算单位新增
    DATA_ACC_UNIT_AD = "fms.data.acct-unit.ad",
    //内部核算单位编辑
    DATA_ACC_UNIT_ED = "fms.data.acct-unit.ed",
    //内部核算单位导出
    DATA_ACC_UNIT_EX = "fms.data.acct-unit.ex",
    //内部核算单位保存
    DATA_ACC_UNIT_SAVE = "fms.data.acct-unit.save",
    // 内部核算单位同步
    DATA_APP_UNIT_SYNC = "fms.data.acct-unit.sync",


    //客户发票管理-开票			
    DATA_INVOICE_INVOICING = "fms.data.invoice.invoicing",
    //客户发票管理-导出		
    DATA_INVOICE_EXPORT = "fms.data.invoice.export",
    //客户发票管理-导出附件			
    DATA_INVOICE_EXPORTATTACH = "fms.data.invoice.exportattach",
    //客户发票管理-开票-单据列表	
    DATA_INVOICE_INVOICING_LIST = "fms.data.invoice.invoicing.list",
    //客户发票管理-开票-上传发票	
    DATA_INVOICE_INVOICING_UPLOAD = "fms.data.invoice.invoicing.upload",
    //客户发票管理-开票-无票收入
    DATA_INVOICE_INVOICING_NOBILL = "fms.data.invoice.invoicing.nobill",
    //客户发票管理-开票-无票申请开票	
    DATA_INVOICE_INVOICING_APPLY = "fms.data.invoice.invoicing.apply",
    //客户发票管理-开票-导出
    DATA_INVOICE_INVOICING_EXPORT = "fms.data.invoice.invoicing.export",
    //客户发票管理-开票-导出附件
    DATA_INVOICE_INVOICING_EXPORTATTACH = "fms.data.invoice.invoicing.exportattach",
    //客户发票管理-开票-开票记录
    DATA_INVOICE_INVOICING_BILLED = "fms.data.invoice.invoicing.billed",
    //客户发票管理-开票-无票申请记录
    DATA_INVOICE_INVOICING_APPLYLIST = "fms.data.invoice.invoicing.applylist",
    //客户发票管理-开票-无票申请记录-开票审核
    DATA_INVOICE_INVOICING_APPROVE = "fms.data.invoice.invoicing.approve",
    //单据发票列表-导出		
    DATA_INVOICE_RECORD_EXPORT = "fms.data.invoice.record.export",
    //单据发票列表-导出附件			
    DATA_INVOICE_RECORD_EXPORTATTACH = "fms.data.invoicee.record.exportattach",

    //合约管理-开户记录-审核	
    DATA_CONTRACT_OPEN_AUDIT = "fms.data.contract.open.audit",
    //合约管理-终止合同
    DATA_CONTRACT_TERMINATE = "fms.data.contract.terminate",

}